import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import moment from 'moment';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import { FETCH_EVENTS } from './graphql';

import {
  Container,
  Loader,
  Column,
  Modal,
  Row,
  Grid,
  Text,
} from './styles';

const EventsModal = ({ open, onClose, tester: { testSessions, user } }) => {
  const testSession = _.first(testSessions);
  const {
    data = {},
    loading,
    error,
  } = useQuery(FETCH_EVENTS, {
    variables: { testSessionId: testSession.id },
    skip: !testSession.id,
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving Events."
      />
    );
  }

  const { playbookuxEvents = [] } = data;

  return (
    <Modal
      size="mini"
      open={open}
      closeOnEscape
      closeOnDimmerClick
      onClose={onClose}
    >
      <Container>
        <Grid columns={1}>
          <Row>
            <Text>
              {user.profile.firstName}
              {' '}
              {user.profile.lastName}
            </Text>
          </Row>
          {loading && <Loader />}
          {!_.isEmpty(playbookuxEvents) && !loading && playbookuxEvents.map(({ name, createdAt }) => (
            <Row>
              <Column width={3}>
                {name}
              </Column>
              <Column width={5}>
                {moment(createdAt).format('MM/DD/YYYY hh:mm A')}
              </Column>
            </Row>
          ))}
        </Grid>
      </Container>
    </Modal>
  );
};

EventsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tester: PropTypes.shape({
    id: PropTypes.string,
    user: PropTypes.shape({
      id: PropTypes.string,
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    }),
    testSessions: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.object]),
    ),
  }),
};

EventsModal.defaultProps = {
  tester: {
    testSessions: [{}],
    user: {
      profile: {},
    },
  },
};

export default EventsModal;
